import React from 'react';
import { Provider } from 'react-redux';
import { Route, RouteChildrenProps } from 'react-router-dom';
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from '../reducers/reducers';
import Error from './Error/Error';
import NewTimesheet from './NewTimesheet/NewTimesheet';
import TimesheetList from './TimesheetList/TimesheetList';

/* eslint-disable no-underscore-dangle */
const composeEnhancers =
  typeof window === 'object' &&
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
      })
    : compose;
/* eslint-enable */

const enhancer = composeEnhancers(applyMiddleware(thunk));
const store = createStore(rootReducer, enhancer);

const MobileApp = ({ match }: RouteChildrenProps) => {
  if (!match) {
    return null;
  }

  return (
    <Provider store={store}>
      <div>
        <Route
          exact
          path={`${match.url}/timesheets`}
          component={TimesheetList}
        />
        <Route
          exact
          path={`${match.url}/new_timesheet`}
          component={NewTimesheet}
        />
        <Error />
      </div>
    </Provider>
  );
};

export default MobileApp;
